var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2976 1.75905C6.66444 1.60115 5.01986 1.60115 3.3867 1.75905C2.51093 1.8438 1.83998 2.73251 1.79996 3.81428C1.67378 7.26912 1.67378 10.7274 1.79996 14.1823C1.83998 15.2652 2.51093 16.1527 3.3867 16.2375C5.01986 16.3954 6.66445 16.3954 8.2976 16.2375C9.17455 16.1527 9.84433 15.264 9.88435 14.1823C9.90671 13.5866 9.92437 12.9816 9.93849 12.3707V5.62585C9.92443 5.02149 9.90638 4.41723 9.88435 3.8131C9.84433 2.73369 9.17455 1.84497 8.2976 1.75905Z",
    fill: "#FEF2E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4629 9.10155C11.4629 9.6854 11.5453 10.507 11.63 11.1992C11.716 11.9054 12.4222 12.3563 13.072 12.0702C14.2632 11.5464 15.3603 10.7707 16.129 9.64067C16.2371 9.48188 16.2949 9.29423 16.2949 9.10214C16.2949 8.91005 16.2371 8.7224 16.129 8.56361C15.3603 7.43358 14.2632 6.65669 13.072 6.13406C12.4222 5.84802 11.716 6.29885 11.63 7.00512C11.5453 7.69726 11.4641 8.51888 11.4641 9.10155H11.4629Z",
    fill: "#FEF2E9",
    stroke: "#F58220",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88552 3.81428C9.84315 2.73134 9.17337 1.8438 8.29643 1.75905C6.66327 1.60115 5.01868 1.60115 3.38552 1.75905C2.51093 1.8438 1.83998 2.73251 1.79996 3.81428C1.67378 7.26912 1.67378 10.7274 1.79996 14.1823C1.83998 15.2652 2.51093 16.1527 3.3867 16.2375C5.01986 16.3954 6.66445 16.3954 8.2976 16.2375C9.17455 16.1527 9.84433 15.264 9.88435 14.1823",
    fill: "#FEF2E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88552 3.81428C9.84315 2.73134 9.17337 1.8438 8.29643 1.75905C6.66327 1.60115 5.01868 1.60115 3.38552 1.75905C2.51093 1.8438 1.83998 2.73252 1.79996 3.81428C1.67378 7.26912 1.67378 10.7274 1.79996 14.1823C1.83998 15.2652 2.51093 16.1527 3.3867 16.2375C5.01986 16.3954 6.66445 16.3954 8.2976 16.2375C9.17455 16.1527 9.84433 15.264 9.88435 14.1823",
    stroke: "#F58220",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41724 9.10156H11.4629H5.41724Z",
    fill: "#FEF2E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41724 9.10156H11.4629",
    stroke: "#F58220",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderRightIcon);
export default __webpack_public_path__ + "static/media/header-right-icon.be0de4e76a504b8ecfde6cc3d487fd4d.svg";
export { ForwardRef as ReactComponent };